export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/decc719ac0c1523cc2040d71b927dcbc.svg";